// CONCEPT: the name of the document event partials/product-browse.js dispatches when a batch of
//          [data-availability] targets has been painted (#1881), in a module of its own so a
//          listener can name it without importing the whole browse painter - the Classic view
//          loads that module lazily.
//
// USE:     document.addEventListener(AVAILABILITY_SETTLED, (e) => e.detail.targets.forEach(...))
//          Each target the answer decided about carries data-order-state:
//          'orderable' | 'out-of-stock' | 'unavailable'.
export const AVAILABILITY_SETTLED = 'pace:availability-settled';
